import PrivateRoute from 'js/components/route_utils/PrivateRoute';
import RouteLoadingComponent from 'js/components/route_utils/RouteLoadingComponent';
import {
  ROUTE_API_KEYS,
  ROUTE_CREDENTIALS,
  ROUTE_DATA_MAPS,
  ROUTE_DATA_SOURCES,
  ROUTE_DESTINATIONS,
  ROUTE_MY_DATA_SETS,
  ROUTE_PIPELINES,
  ROUTE_REDESIGN,
  ROUTE_REUSABLE_TRANSFORMS,
  ROUTE_SCHEMA_SPECS,
} from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { router } from 'new/routes/router';
import React, { memo, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useLastVisitedPath } from 'new/hooks/useSectionNavigation';

const LISTING_PATHS = [
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_PIPELINES}`,
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_DATA_SOURCES}`,
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_MY_DATA_SETS}`,
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_DESTINATIONS}`,
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_CREDENTIALS}`,
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_DATA_MAPS}`,
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_SCHEMA_SPECS}`,
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_REUSABLE_TRANSFORMS}`,
  `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_API_KEYS}`,
];

const IntegrateRoutes = () => {
  const defaultPath = `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_PIPELINES}`;
  const lastVisitedPath = useLastVisitedPath('integrate', ROUTE_CONNECT, defaultPath);

  return (
    <Suspense fallback={<RouteLoadingComponent />}>
      <Switch>
        {Object.keys(router.routesNames.integrate).map((routeName) => {
          const route = router.manager.getRoute(routeName, 'integrate');
          return <PrivateRoute key={routeName} {...route} />;
        })}

        {LISTING_PATHS.map((basePath) => (
          <Route
            key={basePath}
            path={`${basePath}/:id`}
            exact
            render={({
              match: {
                params: { id },
              },
            }) => <Redirect to={`${basePath}?search=id:${id}`} />}
          />
        ))}
        <Route path="*">
          {lastVisitedPath ? <Redirect to={lastVisitedPath} /> : <Redirect to={defaultPath} />}
        </Route>
      </Switch>
    </Suspense>
  );
};

export default memo(IntegrateRoutes);
